import config from "../../../../config";
import * as modules from "./modules/";
const { vendor } = config;

const UserActionsProvider = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default UserActionsProvider;
